import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0131',
    ecrans: ['00-2'],
    params: ['id']
});
